export default "__VITE_ASSET__BU8F2din__"